import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=10798d4e&scoped=true"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=10798d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10798d4e",
  null
  
)

export default component.exports